import { reducer as undelivered } from "./queue/slice";

export const reducer = {
  undelivered,
};
